export default "__VITE_ASSET__Cnh1LXbG__"